/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';


/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';
import { TextControl, Placeholder,__experimentalText as Text,CheckboxControl,SelectControl  } from '@wordpress/components';
import { useState, useEffect } from '@wordpress/element';
import metadata from './block.json';

//import apiFetch from '@wordpress/api-fetch';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

 
export default function Edit({attributes, setAttributes}) {
	const [autoresponders, setautoresponders] = useState(JSON.parse("[{\"label\":\"No autoresponder\",\"value\":\"\"}]"));
	
	if (typeof window.autoresponders !== 'undefined'){
		useEffect(()=>{
			setautoresponders(JSON.parse(window.autoresponders));
		}, [])
	}
	
	return (

        <div { ...useBlockProps() }>
			<div className="inner" >
				<p className="widget-title">{__( metadata.description, 'smaily-for-wp' )}</p>
				<TextControl
					label={__( 'Title', 'smaily-for-wp' )}
					value={ attributes.title }
					name="title"
					id="SM4WP_gutenberg_widget_title"
					onChange={ ( val ) => setAttributes( { title: val } ) }
				/>
				<CheckboxControl
					label={__( 'Display name field?', 'smaily-for-wp' )}
					checked={ attributes.show_name }
					onChange={  ( val ) => setAttributes( { show_name: val } ) }
					name="show_name"
					id="SM4WP_gutenberg_widget_show_name"
				/>
				<TextControl
					label={__( 'Success URL', 'smaily-for-wp' )}
					value={ attributes.success_url }
					name="success_url"
					id="SM4WP_gutenberg_widget_success_url"
					onChange={ ( val ) => setAttributes( { success_url: val } ) }
				/>
				<TextControl
					label={__( 'Failure URL', 'smaily-for-wp' )}
					value={ attributes.failure_url }
					name="failure_url"
					id="SM4WP_gutenberg_widget_failure_url"
					onChange={ ( val ) => setAttributes( { failure_url: val } ) }
				/>
				<SelectControl
					label={__( 'Autoresponders', 'smaily-for-wp' )}
					value={ attributes.autoresponder_id }
					name="autoresponder_id"
					id="SM4WP_gutenberg_widget_autoresponder_id"
					options={ autoresponders }
					onChange={  ( val ) => setAttributes( { autoresponder_id: val } ) }
					__nextHasNoMarginBottom
				/>
			</div>
        </div>
    );
	
}
